import { Input, OnChanges, Directive } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ControlValueAccessor } from '@angular/forms';

@Directive()
export abstract class ConstantSelector implements ControlValueAccessor, OnChanges {
  protected _defaultOptions = [];
  formControl: UntypedFormControl = new UntypedFormControl('');
  @Input() placeholder;
  @Input() options: string[] = this._defaultOptions;
  propagateChange = (value: any) => ({});

  get value() {
    return this.formControl.value;
  }

  writeValue(value) {
    this.formControl.setValue(value);
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  ngOnChanges(inputs) {
    this.propagateChange(this.formControl.value);
  }

  registerOnTouched() {
    // lint
  }
}
